/*
 * CARVERHAUS spec table (blocks/ch-spec-table.liquid).
 * Moves the "Selected" mark to the size row that matches the Size picker,
 * since the product page does not re-render this block on a variant change.
 */
if (!customElements.get('ch-spec-table')) {
  customElements.define(
    'ch-spec-table',
    class ChSpecTable extends HTMLElement {
      connectedCallback() {
        document.addEventListener('change', this.#onChange);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.#onChange);
      }

      /* Selected value of the Size option in this product's variant picker */
      get #size() {
        const picker = this.closest('.product-details')?.querySelector('variant-picker');
        for (const fieldset of picker?.querySelectorAll('fieldset') ?? []) {
          const legend = fieldset.querySelector('legend')?.textContent?.trim().toLowerCase() ?? '';
          if (legend.startsWith('size')) {
            const checked = /** @type {HTMLInputElement | null} */ (fieldset.querySelector('input:checked'));
            return checked?.value?.trim() ?? null;
          }
        }
        const select = picker?.querySelector('select[name*="Size" i]');
        return select ? /** @type {HTMLSelectElement} */ (select).value.trim() : null;
      }

      #onChange = (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        if (!target.closest?.('variant-picker')) return;
        if (target.closest('.product-details') !== this.closest('.product-details')) return;
        const size = this.#size;
        if (!size) return;
        for (const row of this.querySelectorAll('tr[data-ch-size]')) {
          row.classList.toggle('is-current', row.getAttribute('data-ch-size') === size);
        }
      };
    }
  );
}
